import Api from '@/services/Api'

export default {
    getFechas(){
        return Api().get('getFechas')
    },
    getAjustesConsol(codReporte,vigencia){
        return Api().get('getAjustesConsol/'+codReporte+'/'+vigencia)
    },
    consulAjusteOrigen(id,vigencia,idCompany,codReporte){
        return Api().get('getAjustesOrigen/'+id+'/'+vigencia+'/'+idCompany+'/'+codReporte)
    },
    consulAjusteDestino(id,vigencia,codReporte){
        return Api().get('getAjustesDestino/'+id+'/'+vigencia+'/'+codReporte)
    },
    consulAjusteOrigenById(id){
        return Api().get('getAjustesOrigenById/'+id)
    },
    updateAjusteOrigen(datos){
        return Api().put('updateAjusteOrigen',datos)
    },
    consulAjusteDestinoById(id){
        return Api().get('getAjustesDestinoById/'+id)
    },
    updateAjusteDestino(datos){
        return Api().put('updateAjusteDestino',datos)
    },
    borraAjuste(vigencia,secuencia){
        return Api().post('borraAjuste/'+vigencia+'/'+secuencia)
    },
    borraCuentasOrigen(id) {
        return Api().post('borraCuentasOrigen/'+id)
    },
    borraCuentasDestino(id) {
        return Api().post('borraCuentasDestino/'+id)
    },
    crearCuentaNueva(datos) {
        return Api().post('crear-cuenta-nueva', datos)
    },
    crearCuentaNuevaDestino(datos) {
        return Api().post('crear-cuenta-nueva-destino', datos)
    },
    getCompanyName(idCompania) {
        return Api().get('getCompanyName/' + idCompania);
    },
    getReportePrincipal(){
        return Api().get('getReportePrincipal')
    },
}
